<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 20;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = Math.floor(.8 * width);
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg fill="none" {height} viewBox="0 0 17 17" {width} xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_4680_49386)">
		<g clip-path="url(#clip1_4680_49386)">
			<path
				d="M1.86795 10.2378C6.28767 10.2378 10.7074 10.2378 15.1446 10.2378C15.1882 9.96948 15.2318 9.7056 15.2755 9.43724C15.5067 7.92103 15.7423 6.40482 15.9823 4.8886C16.0477 4.48607 15.9561 4.13721 15.6158 3.90016C15.2711 3.66311 14.9177 3.68547 14.573 3.9091C13.7528 4.44134 12.9325 4.96911 12.1123 5.50135C12.0686 5.53266 12.0207 5.55949 11.9639 5.59527C11.7196 5.30903 11.4796 5.02725 11.2397 4.74548C10.5678 3.9583 9.89151 3.16665 9.21961 2.375C8.7964 1.87854 8.20303 1.88301 7.77982 2.37947C6.89849 3.41264 6.01717 4.45029 5.13148 5.48793C5.10093 5.51924 5.07476 5.55502 5.03549 5.59975C4.98313 5.56844 4.93514 5.53713 4.88715 5.50582C4.0669 4.97358 3.24666 4.44134 2.42641 3.91357C1.95085 3.60944 1.4142 3.72125 1.13497 4.17299C1.00408 4.38767 0.977899 4.62472 1.01717 4.86624C1.28767 6.61056 1.55818 8.3504 1.83305 10.0947C1.83741 10.1394 1.85486 10.1842 1.86795 10.2378Z"
				{fill}
			/>
			<path
				d="M14.9746 11.3291C10.6552 11.3291 6.34459 11.3291 2.02522 11.3291C2.11248 11.8926 2.18665 12.4428 2.29136 12.9884C2.40044 13.5609 2.89782 13.9679 3.48683 13.9992C3.53046 14.0037 3.57409 14.0037 3.61772 14.0037C6.87252 14.0037 10.1273 14.0037 13.3821 14.0037C14.0584 14.0037 14.5907 13.6101 14.7085 12.9929C14.8132 12.4473 14.8873 11.8926 14.9746 11.3291Z"
				{fill}
			/>
		</g>
	</g>
	<defs>
		<clipPath id="clip0_4680_49386">
			<rect {fill} height="17" transform="translate(0 0.00390625)" width="17" />
		</clipPath>
		<clipPath id="clip1_4680_49386">
			<rect {fill} height="12" transform="matrix(-1 0 0 1 16 2.00391)" width="15" />
		</clipPath>
	</defs>
</svg>
